import { BaseRule } from '../BaseRule';

class RangeRule extends BaseRule {
	type: string;
	minValue: string;
	maxValue: string;

	constructor(errorMessage: string, validationParameters: any) {
		super('range', errorMessage);
		this.type = validationParameters.operandType;
		this.minValue = validationParameters.minimum;
		this.maxValue = validationParameters.maximum;
	}

	isValidInternal = (val: any) => {
		if (BaseRule.isEmptyValue(val)) {
			return true;
		}

		switch (this.type.toLowerCase()) {
			case 'int':
			case 'int?':
			case 'int32':
			case 'int32?':
			case 'int64':
			case 'int64?':
			case 'float':
			case 'float?':
			case 'double':
			case 'double?':
			case 'decimal':
			case 'decimal?':
			case 'number':
			case 'range': {
				const lessThanMax =
					!isNaN(val) && parseFloat(val) <= parseFloat(this.maxValue);
				const moreThanMin =
					!isNaN(val) && parseFloat(val) >= parseFloat(this.minValue);
				return lessThanMax && moreThanMin;
			}

			case 'datetime':
			case 'datetime?': {
				let dateVal;
				if (typeof val === 'string') {
					dateVal = new Date(val);
				} else {
					dateVal = val;
				}
				const lessThanMax = dateVal <= new Date(this.maxValue);
				const moreThanMin = dateVal >= new Date(this.minValue);
				return lessThanMax && moreThanMin;
			}

			default: {
				const lessThanMax = val <= this.maxValue;
				const moreThanMin = val >= this.minValue;
				return lessThanMax && moreThanMin;
			}
		}
	};
}

export default RangeRule;
